/* Copyright © 2023 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and */
/* matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, */
/* including without limitation, material generated from the software programs which are displayed on the screen such */
/* as icons, screen display looks, etc. */

export enum SettingType {
  Message = 0,
  Text = 1,
  TextArea = 2,
  Checkbox = 3,
  Select = 4,
  MultiSelect = 5,
  Radio = 6,
  SelectConversion = 7,
  NumberCount = 8,
  Toggle = 9,
  Redact = 10,
  SelectWithGroup = 11,
  MultiTranslation = 12,
  Drm = 13,
  PdfConvert = 14,
  XmFax = 15,
  Hidden = 16,
  Categorize = 17,
}

export enum MouseEventType {
  Pressed,
  Released,
  Hovered,
  Outed,
  Moved,
}

export enum MergeMode {
  Concatenate,
  Insert,
  None,
}

export enum InputSource {
  Local = 'SDE_LOCAL_FILE',
  Cloud = 'SDE_CLOUD_REPO',
  Email = 'SDE_EMAIL2',
}

export enum EmailSendCondition {
  Always = 'always',
  Never = 'never',
  OnSuccess = 'onSuccess',
  OnFailure = 'onFailure',
}
